<template>
  <button class="btn" :class="type == 'primary' ? 'btn-primary' : 'btn-default'">
    <div v-if="iconPath" class="icon"><img :src="iconPath" alt="Icon" /></div>
    {{ content }}
  </button>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    content: {
      type: String,
      required: true
    },
    iconPath: {
      type: String,
      default: '' // Path to the SVG file
    }
  }
}
</script>

<style scoped>
.icon {
  width: 20px;
  height: 20px;
  margin-right: .5rem;
}

.btn {
  display: flex;
  align-items: center;
  height: 48px;

  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  transition: background-color 0.2s;

  &.btn-primary {
    background-color: var(--color-500);
    border-color: var(--color-500);
  }

  &.btn-primary:hover {
    background-color: var(--color-600);
    border-color: var(--color-600);
  }

  &.btn-default {
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.1);

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}

@media (max-width: 768px) {
  .btn {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    height: 44px;
    width: 100%;
    justify-content: center;
  }

  .icon {
    width: 18px;
    height: 18px;
    margin-right: 0.4rem;
  }
}
</style>
